var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgMonitor = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("g", {
    clipPath: "url(#clip0_2667_5657)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57716 4.35185C2.45273 4.35185 2.35185 4.45273 2.35185 4.57716V16.2932C2.35185 16.4176 2.45273 16.5185 2.57716 16.5185H21.0525C21.1769 16.5185 21.2778 16.4176 21.2778 16.2932V4.57716C21.2778 4.45273 21.1769 4.35185 21.0525 4.35185H2.57716ZM1 4.57716C1 3.70612 1.70612 3 2.57716 3H21.0525C21.9235 3 22.6296 3.70612 22.6296 4.57716V16.2932C22.6296 17.1643 21.9235 17.8704 21.0525 17.8704H2.57716C1.70612 17.8704 1 17.1643 1 16.2932V4.57716Z",
    fill: props.color || 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08331 20.5741C7.08331 20.2008 7.38594 19.8982 7.75924 19.8982H15.8703C16.2437 19.8982 16.5463 20.2008 16.5463 20.5741C16.5463 20.9474 16.2437 21.25 15.8703 21.25H7.75924C7.38594 21.25 7.08331 20.9474 7.08331 20.5741Z",
    fill: props.color || 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8148 16.5186C12.1881 16.5186 12.4908 16.8212 12.4908 17.1945V20.5741C12.4908 20.9474 12.1881 21.25 11.8148 21.25C11.4415 21.25 11.1389 20.9474 11.1389 20.5741V17.1945C11.1389 16.8212 11.4415 16.5186 11.8148 16.5186Z",
    fill: props.color || 'currentColor'
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_2667_5657"
  }, React.createElement("rect", {
    width: 21.6296,
    height: 18.25,
    fill: props.color || 'currentColor',
    transform: "translate(1 3)"
  }))));
};
export default SvgMonitor;